import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';
import { adminGuard } from './core/admin.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full',
  },
  {
    path: 'welcome',
    loadComponent: () => import('./welcome/welcome.page').then(m => m.WelcomePage)
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'verify-email',
    loadComponent: () => import('./email-verify/email-verify.page').then(m => m.EmailVerifyPage)
  },
  {
    path: 'home',
    canActivate: [authGuard],
    loadComponent: () => import('./home/home.page').then(m => m.HomePage)
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./profile/profile.page').then(m => m.ProfilePage)
  },
  {
    path: 'essay-builder',
    canActivate: [authGuard],
    loadComponent: () => import('./essay-builder/essay-builder.page').then(m => m.EssayBuilderPage)
  },
  {
    path: 'service-plans',
    canActivate: [authGuard],
    loadComponent: () => import('./service-plans/service-plans.page').then(m => m.ServicePlansPage)
  },
  {
    path: 'checkout',
    canActivate: [authGuard],
    loadComponent: () => import('./checkout/checkout.page').then(m => m.CheckoutPage)
  },
  {
    path: 'essay-templates',
    loadComponent: () => import('./essay-templates/essay-templates.page').then(m => m.EssayTemplatesPage)
  },
  {
    path: 'faq',
    loadComponent: () => import('./faq/faq.page').then(m => m.FaqPage)
  },
  {
    path: 'contact',
    loadComponent: () => import('./contact/contact.page').then(m => m.ContactPage)
  },
  {
    path: 'admin',
    children: [
      { path: '', pathMatch: 'full', canActivate: [adminGuard], loadComponent: () => import('./admin/admin.page').then(m => m.AdminPage) },
      { path: 'login', loadComponent: () => import('./admin/admin-login.page').then(m => m.AdminLoginPage) },
    ],
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./reset-password/reset-password.page').then(m => m.ResetPasswordPage)
  },
];
